import { BASE_URL, VENUE } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IVenue, IVenueInput } from "models/venue";
 
export async function getVenues(params: string = "") :Promise<IVenue[] > {
  const response = await axios.get(BASE_URL + VENUE + params);
  return response.data;
}
export async function addVenue(data: IVenueInput) {
  const response = await axios.post(BASE_URL + VENUE, data);
  return response.data;
}
export async function editVenue(data: IVenueInput, id: string) {
  const response = await axios.patch(BASE_URL + VENUE + "/" + id, data);
  return response.data;
}

export async function deleteVenue(id: string) {
  const response = await axios.delete(BASE_URL + VENUE + "/" + id);
  return response.data;
}

export const VenueCells: HeadCell[] = [
  {
    id: "cityId",
    numeric: false,
    disablePadding: false,
    label: "T_city",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "latitude",
    numeric: false,
    disablePadding: false,
    label: "T_latitude",
  },
  {
    id: "longitude",
    numeric: false,
    disablePadding: false,
    label: "T_longitude",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
